export default "__VITE_ASSET__BoJFEkSu__"